import "./Modal.Layout.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
}
export function ModalHeader(props: Props) {
  return <div className={"ModalHeader flex items-center justify-between" + props.className}>{props.children}</div>;
}
